import React, { Component } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import { getWebSessionId } from '../../actions/user';
import { clearCartInfo } from '../../actions/cart'
import { clearOrderInfo } from '../../actions/checkout'
import { compose } from 'redux'
import { successDefault } from '../common/MangoIcons'
import { clearUserDetails } from "../../actions/user"

class orderSuccess extends Component {
    componentDidMount() {
        const { connection_id } = this.props
        document.querySelector("header").style.display = "none";
        // document.querySelector("footer").style.display = "none";
        // this.props.getWebSessionId(connection_id);
        // setTimeout(function(){
        //     this.props.clearCartInfo();
        //     this.props.clearOrderInfo()
        //     document.querySelector("header").style.display = "block";
        //     // document.querySelector("footer").style.display = "block";
        //     this.props.clearUserDetails();
        //     this.props.history.push("/")
        // }.bind(this), 20000);
    }

    handleClose(e) {
        e.preventDefault();
        this.props.clearCartInfo();
        this.props.clearOrderInfo();
        this.props.clearUserDetails();
        document.querySelector("header").style.display = "block";
        // document.querySelector("footer").style.display = "block";
        
        this.props.history.push("/")
    }

    render() {
        const { message } = this.props
        return (
            <div>

                <section className="m-0 p-0">
                    <div className="container success-page">
                        <div className="row justify-content-center">
                            <div className="col-sm-12 col-lg-6" style={{ marginTop: "2%" }}>
                                <div className="mini-title">
                                    <span>Cart Confirmation</span>
                                </div>
                                <div className="mini-title-divider" style={{ marginBottom: 0 }}></div>
                                <div className="success-page-container">
                                    <div className="success-icon">
                                        <img src={successDefault} width={80} alt="" />
                                    </div>
                                    <div className="success-details">
                                        {/* <h2 style={{textTransform: "capitalize"}}>Thank You</h2> */}
                                        <h4 className='success-message' style={{marginBottom: "2rem"}}>Cart Transferred to cash counter.</h4>
                                        <h4 style={{fontWeight: "bold"}}>Proceed to counter for billing.</h4>
                                        {/* <p style={{fontWeight: "bold"}}>{message}</p> */}
                                        <div className="success-button">
                                            <button className="btn btn-solid" onClick={(event) => this.handleClose(event)}>
                                                Continue Shopping
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* <section className="section-b-space light-layout">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="success-text">
                                    <i className="fa fa-check-circle" aria-hidden="true"></i>
                                    <h2>Thank you</h2>
                                    <p>Payment Has Been Received. Your Order is Placed Successfully.</p>
                                    <p>{message}</p>
                                    <b onClick={(event) => this.handleClose(event)} className="btn btn-solid">Continue Shopping</b>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    connection_id: state.tenant.connection_id,
})

export default compose(
    withRouter,
    connect(mapStateToProps,
        { getWebSessionId, clearCartInfo, clearOrderInfo, clearUserDetails })
)(orderSuccess);